import { createTanstackQueryUtils } from '@orpc/tanstack-query';

import { client } from './rpc';

/** Global oRPC utils — for routes outside workspace context (auth, public, invite). */
export const orpc = createTanstackQueryUtils(client);

/**
 * Workspace-scoped oRPC utils — keys are prefixed with the workspace slug.
 * E.g., getOrpc('ws-a').chat.list.queryOptions({}).queryKey → [['ws-a', 'chat', 'list'], ...]
 * Cache naturally isolates per workspace; switching back shows cached data instantly.
 */
const orpcCache = new Map<string, ReturnType<typeof createTanstackQueryUtils<typeof client>>>();

export function getOrpc(slug: string): ReturnType<typeof createTanstackQueryUtils<typeof client>> {
  let utils = orpcCache.get(slug);
  if (!utils) {
    utils = createTanstackQueryUtils(client, { path: [slug] });
    orpcCache.set(slug, utils);
  }
  return utils;
}
